import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button } from "reactstrap";
import { useIntl } from "react-intl";
import { useRouterCore } from "../../../cores/router";

export const UpgradePlanButton = () => {
  const intl = useIntl();
  const { goToPlans } = useRouterCore();
  return (
    <Button
      style={{backgroundColor: '#FF7A59', borderColor: '#FF7A59'}}
      className="mx-2"
      onClick={goToPlans}
    >
      <FontAwesomeIcon icon={["fas", "angle-double-up"]} className="mx-2" />
      {intl.formatMessage({ id: "app.contacts.upgradePlan" })}
    </Button>
  );
};
